module.exports = __webpack_public_path__ + "img/bombas_tipo_ansi.f0651f1b.jpg";